import { apiClient } from "./index";

class LayoutService {
// Get all Header
static getHeader(productID:any) {
  return apiClient.get(`product-pages/${productID}/header`,{
    headers: {
        "x-product-id": productID,
    }
   });
 } 
 // Get all Footer
  static getFooter(productID:any) {
    return apiClient.get(`product-pages/${productID}/footer`,{
      headers: {
          "x-product-id": productID,
      }
     });
  }
  // Get all Policies
  static getPolicies(productID: any) {
    return apiClient.get(`product-pages/${productID}/policies`,{
      headers: {
          "x-product-id": productID,
      }
     });
  }
  // Get all Thank you
  static getThank(productID: any) {
    return apiClient.get(`product-pages/${productID}/thank-you-page-settings`,{
      headers: {
          "x-product-id": productID,
      }
     });
  }
  // Get all Settings
  static getSettings(productID: any) {
    return apiClient.get(`product-pages/${productID}/settings`,{
      headers: {
          "x-product-id": productID,
      }
     });
  }
  // Print invoice
  static printInvoice(id:any) {
    return apiClient.get(`orders/print-invoice/${id}`,{ 
      responseType: "blob",
      headers: {
          "x-product-id": id,
      }
    });
  }

}
export default LayoutService;
